module.exports = __webpack_public_path__ + "img/5-4.7e524fe7.jpg";